export default () => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="11065"
    >
      <path
        d="M703.664 324.48H301.008a36.944 36.944 0 1 1 0-73.888h402.656a36.576 36.576 0 0 1 36.944 36.944 37.04 37.04 0 0 1-36.944 36.944z"
        p-id="11066"
      ></path>
      <path
        d="M703.664 513.744H301.008a36.944 36.944 0 1 1 0-73.888h402.656a36.576 36.576 0 0 1 36.944 36.944 37.04 37.04 0 0 1-36.944 36.944z"
        p-id="11067"
      ></path>
      <path
        d="M703.664 702.256H301.008a36.944 36.944 0 1 1 0-73.888h402.656a36.576 36.576 0 0 1 36.944 36.944 37.04 37.04 0 0 1-36.944 36.944z"
        p-id="11068"
      ></path>
      <path
        d="M705.776 992H116.416a36.208 36.208 0 0 1-36.432-36.704V68.704A36.208 36.208 0 0 1 116.416 32h791.152a36.208 36.208 0 0 1 36.416 36.704V936.96a36.432 36.432 0 1 1-72.848 0V105.392H152.832v813.216H705.76a36.208 36.208 0 0 1 36.432 36.704A36.672 36.672 0 0 1 705.776 992z"
        p-id="11069"
      ></path>
    </svg>
  );
};
